/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Tier2ServiceCompleteResponse
 */
export interface Tier2ServiceCompleteResponse {
    /**
     * 
     * @type {string}
     * @memberof Tier2ServiceCompleteResponse
     */
    tier2Id?: string | null;
}

/**
 * Check if a given object implements the Tier2ServiceCompleteResponse interface.
 */
export function instanceOfTier2ServiceCompleteResponse(value: object): value is Tier2ServiceCompleteResponse {
    return true;
}

export function Tier2ServiceCompleteResponseFromJSON(json: any): Tier2ServiceCompleteResponse {
    return Tier2ServiceCompleteResponseFromJSONTyped(json, false);
}

export function Tier2ServiceCompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): Tier2ServiceCompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tier2Id': json['tier2Id'] == null ? undefined : json['tier2Id'],
    };
}

export function Tier2ServiceCompleteResponseToJSON(json: any): Tier2ServiceCompleteResponse {
    return Tier2ServiceCompleteResponseToJSONTyped(json, false);
}

export function Tier2ServiceCompleteResponseToJSONTyped(value?: Tier2ServiceCompleteResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tier2Id': value['tier2Id'],
    };
}

